import React, { useEffect } from 'react';

interface FormProps {
  onSubmit?: () => void;
  onChange?: () => void;
  encType?: string;
  formId?: string;
  onNewForm?: () => void;
}

const Form: React.FC<FormProps> = ({ onSubmit, onChange, formId, onNewForm, ...props }) => {
  useEffect(() => {
    if (formId && onNewForm) {
      onNewForm();
    }
  }, [formId, onNewForm]);

  return <form onSubmit={onSubmit} onChange={onChange} {...props} noValidate />;
};

export default Form;
